<script>
  import { Transfer } from 'element-ui'
  export default {
    name:'ElTransfer',
    extends:Transfer
  }
</script>
